import { request } from './http';

export async function getRaciUsersForFacility(facilityId, view = 'ComplianceView') {
    const q = view ? `?view=${encodeURIComponent(view)}` : '';
    return request(`/facilities/${facilityId}/raci-users${q}`);
  }

export async function getRaciUsersForSites(siteIds, view = 'ComplianceView') {
    return request('/compliance/raci-users-for-sites', {
      method: 'POST',
      body: JSON.stringify({ siteIds, view }),
    });
  }

export async function getRaciUsersForCompany(companyId, view = 'ComplianceView') {
    const q = view ? `?view=${encodeURIComponent(view)}` : '';
    return request(`/companies/${companyId}/raci-users${q}`);
  }

export async function getRaciAssignmentsForRecord(recordId) {
    return request(`/compliance/${recordId}/raci-assignments`);
  }

export async function getComplianceRaciEditPermissions(recordId) {
    return request(`/compliance/${recordId}/raci-edit-permissions`);
  }

export async function setRaciAssignmentsForRecord(recordId, assignments) {
    return request(`/compliance/${recordId}/raci-assignments`, {
      method: 'POST',
      body: JSON.stringify(assignments),
    });
  }

export async function getRaciAssignmentsForSite(siteId) {
    return request(`/data/sites/${siteId}/raci-assignments`);
  }

export async function setRaciAssignmentsForSite(siteId, assignments) {
    return request(`/data/sites/${siteId}/raci-assignments`, {
      method: 'POST',
      body: JSON.stringify(assignments),
    });
  }

export async function getPwsLogRecordAssignments({ table, siteId, status = 'all' }) {
    const params = new URLSearchParams({ table, siteId: String(siteId), status });
    return request(`/pws/log-record-assignments?${params.toString()}`);
  }

export async function assignPwsLogRecordsLatest({ table, siteId, userId }) {
    return request('/pws/log-record-assignments', {
      method: 'POST',
      body: JSON.stringify({ table, siteId, userId, mode: 'latest' }),
    });
  }

export async function bulkAssignPwsLogRecords({ table, recordIds, userId }) {
    return request('/pws/log-record-assignments/bulk', {
      method: 'POST',
      body: JSON.stringify({ table, recordIds, userId }),
    });
  }

export async function getRaciAssignmentsForEnvironmentalSampling(recordId) {
    return request(`/testing/environmental-sampling/${recordId}/raci-assignments`);
  }

export async function setRaciAssignmentsForEnvironmentalSampling(recordId, assignments) {
    return request(`/testing/environmental-sampling/${recordId}/raci-assignments`, {
      method: 'POST',
      body: JSON.stringify(assignments),
    });
  }

export async function getRaciAssignmentsForEnvironmentalLabAnalysis(recordId) {
    return request(`/testing/environmental-lab-analysis/${recordId}/raci-assignments`);
  }

export async function setRaciAssignmentsForEnvironmentalLabAnalysis(recordId, assignments) {
    return request(`/testing/environmental-lab-analysis/${recordId}/raci-assignments`, {
      method: 'POST',
      body: JSON.stringify(assignments),
    });
  }

export const raciAssignmentsApi = {
  getRaciUsersForFacility,
  getRaciUsersForSites,
  getRaciUsersForCompany,
  getRaciAssignmentsForRecord,
  getComplianceRaciEditPermissions,
  setRaciAssignmentsForRecord,
  getRaciAssignmentsForSite,
  setRaciAssignmentsForSite,
  getPwsLogRecordAssignments,
  assignPwsLogRecordsLatest,
  bulkAssignPwsLogRecords,
  getRaciAssignmentsForEnvironmentalSampling,
  setRaciAssignmentsForEnvironmentalSampling,
  getRaciAssignmentsForEnvironmentalLabAnalysis,
  setRaciAssignmentsForEnvironmentalLabAnalysis,
};

